export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 2a1 1 0 011 1v5c0 1.633.354 2.465.74 2.89.366.402.918.61 1.76.61v2c-1.158 0-2.356-.292-3.24-1.264-.703-.773-1.096-1.855-1.218-3.236h-1.517c.067 1.414.284 2.454.702 3.312.501 1.029 1.343 1.905 2.812 2.845.316.203.492.566.456.939l-.477 5a1 1 0 01-.997.904H6.5a1 1 0 01-1-1c0-5.229-.016-8.416 2.034-12H5a1 1 0 01-1-1 6 6 0 016-6h7zM9.893 9c-2.232 3.294-2.38 5.886-2.39 11h8.61l.334-3.5c-1.384-.962-2.378-1.998-3.018-3.311-.516-1.058-.771-2.238-.872-3.596L12.523 9h-2.63zM10 4a4.002 4.002 0 00-3.874 3H16V4h-6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};